import { OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import {
    UpdateCartLineApiParameter,
    updateCartLineWithResult as updateCartLineApi,
} from "@dana/Overrides/Services/CartService";
import loadAnnualReturnsCart from "@dana/Store/Data/AnnualReturnsCart/AnnualReturnsCartHandler";
import loadEmergencyCart from "@dana/Store/Data/EmergencyCart/EmergencyCartHandler";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { Dictionary } from "@insite/client-framework/Common/Types";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateCartLineParameter {
    onSuccess?: (line?: CartLineModel) => void;
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
    isEmergencyOrder?: boolean;
    isAnnualReturnsOrder?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const DispatchBeginUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    props.dispatch({
        type: "Pages/Cart/BeginUpdateCartLine",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        cartId: API_URL_CURRENT_FRAGMENT,
    };
    if (props.parameter.isEmergencyOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.EMERGENCY) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true,
            }
        }
    } else if (props.parameter.isEmergencyOrder) {
        props.apiParameter.additionalQueryStringParameters = {
            "IsEmergencyOrder": true,
        }
    }

    if (props.parameter.isAnnualReturnsOrder === undefined) {
        const orderType = getCookie('modalOrderType');
        if (orderType === OrderTypes.ANNUALRETURNS) {
            props.apiParameter.additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }
    } else if (props.parameter.isAnnualReturnsOrder !== undefined && props.parameter.isAnnualReturnsOrder) {
        props.apiParameter.additionalQueryStringParameters = {
            "IsAnnualReturnsOrder": true
        }
    }
};

export const UpdateCartLine: HandlerType = async props => {
    const result = await updateCartLineApi(props.apiParameter);
    if (result.successful) {
        props.apiParameter.cartLine = result.result
    }
};

export const LoadCart: HandlerType = props => {
    if (props.apiParameter?.additionalQueryStringParameters?.IsEmergencyOrder) {
        props.dispatch(loadEmergencyCart({
            cartId: API_URL_CURRENT_FRAGMENT
        }));
    }
    else if (props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder && props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder === true) {
        props.dispatch(loadAnnualReturnsCart({
            cartId: API_URL_CURRENT_FRAGMENT
        }));
    }
    else {
        props.parameter.shouldNotLoadFullCart
            ? props.dispatch(
                loadCurrentCart({
                    shouldLoadFullCart: false,
                    getCartLines: true,
                    getCostCodes: true,
                    getPromotions: !props.parameter.shouldNotReloadPromotions,
                }),
            )
            : props.dispatch(loadCurrentCart({ getPromotions: !props.parameter.shouldNotReloadPromotions }));
    }

};

/** @deprecated Not needed anymore */
export const LoadPromotions: HandlerType = () => { };

export const DispatchCompleteUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Pages/Cart/CompleteUpdateCartLine",
    });
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props?.apiParameter?.cartLine);
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateApiParameter,
    UpdateCartLine,
    LoadCart,
    LoadPromotions,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
];

const updateCartLine = createHandlerChainRunner(chain, "UpdateCartLine");
export default updateCartLine;
